import type { Article, Category, GuideSeed, MarketingLocale } from "./types";
import { englishGuides } from "./english";
import { greekGuides } from "./greek";
import { internationalGuides } from "./international";
import { ui } from "./locales";

export const CONTENT_DATE = "2026-10-04";
export const categories: Category[] = ["getting-started", "ai-prompts", "cost-and-maintenance", "business-websites", "seo-and-domains", "design-and-content"];
export const PAGE_SIZE = 12;

function articleFromSeed(seed: GuideSeed, locale: MarketingLocale): Article {
  const [slug, title, category, keyword, intro, heading, advice, checklist, prompt, takeaway] = seed;
  return {
    id: slug, slug, locale, title, description: intro.length > 155 ? `${intro.slice(0, 152).replace(/\s+\S*$/, "")}…` : intro,
    category, keywords: [keyword, ui[locale].categories[category], "Kate"], intro,
    sections: [{ heading, paragraphs: advice.split("\n\n") }, { heading: ui[locale].checklist, paragraphs: [], checklist: checklist.split("|") }],
    prompt: prompt || undefined, takeaway, published: CONTENT_DATE, updated: CONTENT_DATE,
    sources: category === "seo-and-domains" ? [{ label: "Google Search Central", url: "https://developers.google.com/search/docs/fundamentals/seo-starter-guide" }] : undefined
  };
}

export const articles: Article[] = [
  ...englishGuides.map(seed => articleFromSeed(seed, "en")),
  ...greekGuides.map(seed => articleFromSeed(seed, "el")),
  ...internationalGuides.flatMap(({ locale, guides }) => guides.map(seed => articleFromSeed(seed, locale)))
];

export function articlesFor(locale: MarketingLocale, category?: Category) {
  return articles.filter(article => article.locale === locale && (!category || article.category === category));
}
export function findArticle(locale: MarketingLocale, slug: string) { return articles.find(article => article.locale === locale && article.slug === slug); }
export function translations(article: Article) { return articles.filter(other => other.id === article.id); }
export function relatedArticles(article: Article) {
  return articlesFor(article.locale).filter(other => other.id !== article.id)
    .sort((a, b) => Number(b.category === article.category) - Number(a.category === article.category)).slice(0, 3);
}
export function articleWords(article: Article) {
  return [article.title, article.intro, ...article.sections.flatMap(section => [section.heading, ...section.paragraphs, ...(section.checklist || [])]), article.prompt || "", article.takeaway, ui[article.locale].cta].join(" ").trim().split(/\s+/).length;
}
